import React from "react";
import { useNavigate } from "react-router-dom"; // ← import this


export default function About() {
  const navigate = useNavigate(); // ← initialize

  return (
   <div className="max-w-4xl mx-auto px-6 py-12 space-y-10 text-gray-700">
  <section>
    <h1 className="text-3xl font-bold text-blue-700 mb-4">About RealMaps</h1>
    <p>
      RealMap is a property insight tool built for Monmouth County, NJ. Our mission is to help buyers,
      investors, and agents explore sale data in a visual, intuitive way.
    </p>
  </section>

  <section>
    <h2 className="text-2xl font-semibold mb-2">Data Source</h2>
    <p>
      Sale records are sourced from the official Monmouth County OPRS system. We update weekly on Monday by 1 P.M. EST.
    </p>
  </section>

  <section>
    <h2 className="text-2xl font-semibold mb-2">Version</h2>
    <p>
      You are currently using <strong>RealMaps v1.1</strong>. Future updates will support more counties and advanced filters.
    </p>
  </section>

  <section>
    <h2 className="text-2xl font-semibold mb-2">Feedback</h2>
    <p className="mb-4">
      Questions or bug reports? Email <a href="mailto:tonyclark1996@gmail.com" className="text-blue-600 underline">tonyclark1996@gmail.com</a>.
    </p>
    <button
      onClick={() => navigate("/login")}
      className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
    >
      Login / Sign Up
    </button>
  </section>
</div>

  );
}
